module.exports = __webpack_public_path__ + "media/images/voice_logo21-e60807215262361a7e4aa6a91ebd9cd7.png";